/**
 * Слайдеры страницы.
 *
 * Swiper (181 КБ исходника) загружается динамически и только если на
 * странице есть хотя бы один слайдер. Проверка обязательна: `new Swiper()`
 * по отсутствующему селектору молча создаёт пустой инстанс, из-за чего
 * библиотека тянулась на все страницы темы.
 */

const SELECTORS = {
    leaders: '.leaders__slider-slides',
    reviews: '.reviews__content',
    teachers: '.teachers__slides',
};

export default async function Sliders() {
    const nodes = {};
    for (const [key, selector] of Object.entries(SELECTORS)) {
        nodes[key] = document.querySelector(selector);
    }

    if (!Object.values(nodes).some(Boolean)) return;

    // Ядро и модули — два отдельных входа пакета, грузятся параллельно
    const [{default: Swiper}, {Navigation, Pagination, Autoplay, EffectFade}] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    if (nodes.leaders) {
        new Swiper(SELECTORS.leaders, {
            modules: [Autoplay],
            loop: true,
            grabCursor: true,
            autoHeight: false,
            speed: 2000,
            slidesPerView: 1.8,
            spaceBetween: 20,
            autoplay: {
                delay: 0,
                disableOnInteraction: true,
            },
            breakpoints: {
                992: {
                    spaceBetween: 40,
                    slidesPerView: 6.15,
                },
            }
        });
    }

    if (nodes.reviews) {
        new Swiper(SELECTORS.reviews, {
            modules: [Navigation, Pagination, EffectFade],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 2000,
            autoHeight: true,
            allowTouchMove: true,
            effect: 'fade',
            watchSlidesProgress: true,
            virtualTranslate: true,
            grabCursor: true,
            slideVisibleClass: 'review-active',
            navigation: {
                nextEl: '.reviews__next',
                prevEl: '.reviews__prev',
            },
            pagination: {
                el: '.reviews__pagination',
                clickable: true,
            },
            on: {
                slideChange(slider) {
                    let activeSlide = document.querySelector('.reviews__slide.swiper-slide-active');
                    if (!activeSlide) return;
                    let iframe = activeSlide.querySelector('iframe');
                    let cover = activeSlide.querySelector('.reviews__cover img');
                    let play = activeSlide.querySelector('.reviews__play');
                    if (iframe) iframe.remove();
                    if (cover) cover.classList.remove('hidden');
                    if (play) play.classList.remove('hidden');
                },
                slideNextTransitionStart(slider) {
                    slider.el.classList.add('swiper-direction-next');
                    slider.el.classList.remove('swiper-direction-prev');
                },
                slidePrevTransitionStart(slider) {
                    slider.el.classList.remove('swiper-direction-next');
                    slider.el.classList.add('swiper-direction-prev');
                    slider.isBeginning ? slider.slides[slider.activeIndex].classList.add('swiper-slide-first') : null;
                },
            },
            breakpoints: {
                992: {
                    autoHeight: false,
                }
            }
        });
    }

    if (nodes.teachers) {
        new Swiper(SELECTORS.teachers, {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 600,
            grabCursor: true,
            autoHeight: false,
            navigation: {
                nextEl: '.teachers__next',
                prevEl: '.teachers__prev',
            },
            pagination: {
                el: '.teachers__pagination',
                clickable: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    slidesPerGroup: 3
                },
            }
        });
    }
}
